import { Checkbox } from "@mui/material";
import { useEffect, useState } from "react";

export interface CheckBoxProps {
  onChange?: (checked: boolean) => void;
  active?: boolean;
  indeterminate?: boolean;
}
export default function CheckBox({ onChange, active, indeterminate }: CheckBoxProps) {
  const [checked, setChecked] = useState(active || false);
  useEffect(() => onChange && onChange(checked), [checked]);
  return <Checkbox checked={checked} indeterminate={indeterminate} onClick={() => setChecked((x) => !x)} />;
}
